<template>
    <b-card no-body>
        <b-card-header>
            <span class="h5">
                PRÉ-CONTRATO -
                <b-badge variant="warning">{{ operacao }}</b-badge>
            </span>
        </b-card-header>
        <b-card-body>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <div>
                <b-row>
                    <b-col sm="12" md="2">
                        <b-form-group>
                            <label for="numeroContrato"
                                >Número do contrato</label
                            >
                            <b-input-group>
                                <b-form-input
                                    type="text"
                                    id="numeroContrato"
                                    placeholder="Digite o número do contrato"
                                    v-model="preContratoDto.vcCodigoEstruturado"
                                    v-mask="'AA###/##'"
                                    :disabled="!habilitaCampos"
                                ></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="2">
                        <b-form-group>
                            <label for="tipoContratacao"
                                >Tipo da contratação</label
                            >
                            <b-form-select
                                class="mb-2 mr-sm-2 mb-sm-0"
                                :plain="true"
                                :options="tiposContratacao"
                                v-model="preContratoDto.tpContratacao"
                                @change="selecionaTipoContratacao($event)"
                                :disabled="edicaoPreContrato || !habilitaCampos"
                            ></b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="2" v-if="!isTermoCadastramento">
                        <b-form-group>
                            <label for="tipoLicitacao">Tipo da Licitação</label>
                            <b-form-select
                                class="mb-2 mr-sm-2 mb-sm-0"
                                :plain="true"
                                :options="tiposLicitacao"
                                v-model="preContratoDto.codTipoLicitacao"
                                @change="mudarLabelReferenteLicitacao($event)"
                                :disabled="!habilitaCampos"
                            ></b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="2" v-if="!isTermoCadastramento">
                        <b-form-group>
                            <label for="numRef"
                                >Número {{ tipoLicitacaoSelecionado }}
                            </label>
                            <b-input-group>
                                <b-form-input
                                    type="text"
                                    id="numRef"
                                    placeholder="Digite o número"
                                    v-model="
                                        preContratoDto.numProcessoLicitacao
                                    "
                                    :disabled="!habilitaCampos"
                                    @input.native="
                                        $v.preContratoDto.numProcessoLicitacao.$touch()
                                    "
                                    :state="
                                        $v.preContratoDto.numProcessoLicitacao
                                            .$error
                                            ? false
                                            : null
                                    "
                                ></b-form-input>
                                <b-form-invalid-feedback
                                    >O número {{ tipoLicitacaoSelecionado }} é
                                    obrigatório</b-form-invalid-feedback
                                >
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="2">
                        <b-form-group>
                            <label
                                v-show="mostraFormaAutorizacao"
                                for="formaAutorizacao"
                                >Forma de Autorização</label
                            >
                            <b-form-select
                                class="mb-2 mr-sm-2 mb-sm-0"
                                :plain="true"
                                :options="formasAutorizacao"
                                v-model="preContratoDto.formaAutorizacao"
                                v-show="mostraFormaAutorizacao"
                                :disabled="!habilitaCampos"
                            ></b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="2">
                        <b-form-group
                            :state="
                                $v.preContratoDto.dataAutorizacaoMapa.$error
                                    ? false
                                    : null
                            "
                            invalid-feedback="Data da autozização é obrigatória"
                        >
                            <label v-show="mostraFormaAutorizacao"
                                >Data Autozização</label
                            >
                            <date-picker
                                v-model="preContratoDto.dataAutorizacaoMapa"
                                :config="$datePickerOptions"
                                v-mask="'##/##/####'"
                                @input.native="
                                    $v.preContratoDto.dataAutorizacaoMapa.$touch()
                                "
                                v-show="mostraFormaAutorizacao"
                                :disabled="!habilitaCampos"
                            ></date-picker>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="2">
                        <b-form-group>
                            <label v-show="mostraNumeroMapa" for="numeroMapa"
                                >Número do Mapa</label
                            >
                            <b-input-group>
                                <b-form-input
                                    type="text"
                                    id="numeroMapa"
                                    placeholder="Digite o número do mapa"
                                    v-model="preContratoDto.numeroMapa"
                                    v-show="mostraNumeroMapa"
                                    :disabled="!habilitaCampos"
                                ></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col
                        sm="12"
                        md="3"
                        v-if="mostraPesquisaAtaESelecaoDeProcesso"
                    >
                        <b-form-group>
                            <label for="ataDirex">Ata Direx</label>
                            <b-input-group>
                                <b-form-input
                                    type="text"
                                    id="ataDirex"
                                    placeholder="Digite o código da Ata"
                                    v-model="preContratoDto.ata"
                                    @input.native="
                                        $v.preContratoDto.ata.$touch()
                                    "
                                    :state="
                                        $v.preContratoDto.ata.$error
                                            ? false
                                            : null
                                    "
                                    @keyup="modificaNumeroAta()"
                                    v-mask="'##/####'"
                                    :disabled="!habilitaCampos"
                                ></b-form-input>
                                <b-input-group-append>
                                    <b-button
                                        variant="primary"
                                        @click="pesquisarAtaDirex()"
                                        title="Clique para pesquisar a Ata Direx"
                                        :disabled="!habilitaCampos"
                                    >
                                        <i class="fa fa-search"></i>
                                    </b-button>
                                </b-input-group-append>
                                <b-form-invalid-feedback
                                    >O código da Ata é
                                    obrigatório</b-form-invalid-feedback
                                >
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col
                        sm="12"
                        md="3"
                        v-if="!mostraPesquisaAtaESelecaoDeProcesso"
                    >
                        <b-form-group>
                            <label for="processo">Processo</label>
                            <b-input-group>
                                <b-form-input
                                    type="text"
                                    id="processo"
                                    v-mask="'############'"
                                    @keyup="modificaNumeroProcesso()"
                                    placeholder="Digite o número do processo"
                                    v-model="preContratoDto.vcProcessoAditivo"
                                    @input.native="
                                        $v.preContratoDto.vcProcessoAditivo.$touch()
                                    "
                                    :state="
                                        $v.preContratoDto.vcProcessoAditivo
                                            .$error
                                            ? false
                                            : null
                                    "
                                    :disabled="!habilitaCampos"
                                ></b-form-input>
                                <b-input-group-append>
                                    <b-button
                                        variant="primary"
                                        @click="obterProcessoPorNumero()"
                                        title="Clique para pesquisar o processo"
                                        :disabled="!habilitaCampos"
                                    >
                                        <i class="fa fa-search"></i>
                                    </b-button>
                                </b-input-group-append>
                                <b-form-invalid-feedback
                                    >O código do processo é
                                    obrigatório</b-form-invalid-feedback
                                >
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col
                        sm="12"
                        md="3"
                        v-if="mostraPesquisaAtaESelecaoDeProcesso"
                    >
                        <b-form-group>
                            <label for="numeroProcesso"
                                >Número do processo</label
                            >
                            <b-form-select
                                class="mb-2 mr-sm-2 mb-sm-0"
                                :plain="true"
                                :options="processosAta"
                                text-field="nuProcesso"
                                value-field="idProcessoAta"
                                :selected="selecionado"
                                @change="selecionaNumeroProcesso($event)"
                                v-model="processoAta.nuProcesso"
                                @input="$v.processoAta.$touch()"
                                :state="$v.processoAta.$error ? false : null"
                                :disabled="!habilitaCampos"
                            ></b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="4">
                        <b-form-group>
                            <label for="solictGedoc">Solicitante GEDOC</label>
                            <b-input-group>
                                <b-form-input
                                    type="text"
                                    id="solictGedoc"
                                    v-model="processoAta.vcNomeSolicitanteGdoc"
                                    :disabled="true"
                                ></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="12">
                        <b-form-group>
                            <label>Objeto do Contrato</label>
                            <b-form-textarea
                                v-model="preContratoDto.vcObjetoContrato"
                                :rows="3"
                                @input="
                                    $v.preContratoDto.vcObjetoContrato.$touch()
                                "
                                :state="
                                    $v.preContratoDto.vcObjetoContrato.$error
                                        ? false
                                        : null
                                "
                                :disabled="!habilitaCampos"
                            ></b-form-textarea>
                            <b-form-invalid-feedback
                                >O objeto contrato é
                                obrigatório</b-form-invalid-feedback
                            >
                        </b-form-group>
                    </b-col>
                </b-row>
                <!-- <b-row>
                    <b-col sm="12" md="3">
                        <b-form-group>
                            <label for="cpfcnpj">CPF/CNPJ Formecedor</label>
                            <b-input-group>
                                <b-form-input
                                    type="text"
                                    id="cpfcnpj"
                                    placeholder="Digite o CPF ou CNPJ do fornecedor"
                                    v-model="fornecedor.cnpjcpf"
                                    v-mask="[
                                        '###.###.###-##',
                                        '##.###.###/####-##'
                                    ]"
                                    @input="$v.fornecedor.cnpjcpf.$touch()"
                                    :state="
                                        $v.fornecedor.cnpjcpf.$error
                                            ? false
                                            : null
                                    "
                                    :disabled="!habilitaCampos"
                                ></b-form-input>
                                <b-input-group-append>
                                    <b-button
                                        variant="primary"
                                        @click="pesquisarFornecedor()"
                                        title="Clique para pesquisar o fornecedor"
                                        :disabled="!habilitaCampos"
                                    >
                                        <i class="fa fa-search"></i>
                                    </b-button>
                                </b-input-group-append>
                                <b-form-invalid-feedback
                                    >O CPF ou CNPJ do fornecedor é
                                    obrigatório</b-form-invalid-feedback
                                >
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="5">
                        <b-form-group>
                            <label for="razaoSocial">Razão social</label>
                            <b-input-group>
                                <b-form-input
                                    type="text"
                                    id="razaoSocial"
                                    v-model="fornecedor.razaoSocial"
                                    :disabled="true"
                                    @input="$v.fornecedor.razaoSocial.$touch()"
                                    :state="
                                        $v.fornecedor.razaoSocial.$error
                                            ? false
                                            : null
                                    "
                                ></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row> -->
                <b-row>
                    <b-col sm="12" md="3" v-if="!fornecedor.fornecedorExterno">
                        <b-form-group >
                            <label class="required" >CPF/CNPJ Formecedor</label>
                            <b-input-group>
                                <b-form-input
                                    type="text"
                                    maxlength="18"
                                    placeholder="Digite o CPF ou CNPJ do fornecedor"
                                    v-model="fornecedor.cnpjcpf"
                                    
                                ></b-form-input>
                                <b-input-group-append>
                                    <b-button
                                        variant="primary"
                                        @click="pesquisarFornecedor()"
                                        title="Clique para pesquisar o fornecedor"
                                    >
                                        <i class="fa fa-search"></i>
                                    </b-button>
                                </b-input-group-append>
                                <b-form-invalid-feedback>
                                    O CPF ou CNPJ do fornecedor é obrigatório
                                </b-form-invalid-feedback>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="3" v-if="fornecedor.fornecedorExterno">
                        <b-form-group >
                            <label class="required" >Código Formecedor</label>
                            <b-input-group>
                                <b-form-input
                                    type="text"
                                    maxlength="8"
                                    placeholder="Digite o Código do fornecedor"
                                    v-model="fornecedor.codFornecedor"
                                ></b-form-input>
                                <b-input-group-append>
                                    <b-button
                                        variant="primary"
                                        @click="pesquisarFornecedor()"
                                        title="Clique para pesquisar o fornecedor"
                                    >
                                        <i class="fa fa-search"></i>
                                    </b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md=2>
                        <b-form-group>
                            <label>
                            </label>
                            <b-checkbox
                                v-model="fornecedor.fornecedorExterno"
                            >
                                Fornecedor Estrangeiro
                            </b-checkbox>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="5">
                        <b-form-group>
                            <label for="razaoSocial">Razão social</label>
                            <b-input-group>
                                <b-form-input
                                    type="text"
                                    id="razaoSocial"
                                    v-model="fornecedor.razaoSocial"
                                    :disabled="true"
                                ></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="12" md="12">
                        <label for="tblItensContrato">Itens do contrato</label>
                        <app-tabela
                            idTabela="tblItensContrato"
                            :itens="preContratoDto.itensContrato"
                            :campos="campos"
                            :itensPorPagina="itensPorPagina"
                        >
                            <template slot="botoes">
                                <div class="d-flex flex-row-reverse mb-3">
                                    <btn-inserir-item-contrato
                                        v-on:salvarItemContrato="
                                            salvarItemContrato
                                        "
                                        :desativarBotao="!habilitaCampos"
                                    ></btn-inserir-item-contrato>
                                </div>
                            </template>
                            <template slot="acoes" slot-scope="data">
                                <btn-editar-item-contrato
                                    :parentData="data"
                                    :desativarBotao="!habilitaCampos"
                                    v-on:editarItemContrato="
                                        atualizarItemContrato
                                    "
                                ></btn-editar-item-contrato>
                                <span class="text-danger float-left mr-2">
                                    <i
                                        class="fa fa-trash fa-lg icon-button"
                                        title="Excluir item contrato"
                                        @click.stop="
                                            confirmarRemocaoItemContrato(data)
                                        "
                                    ></i>
                                </span>
                                <btn-inserir-Subitem
                                    :parentData="data"
                                    :desativarBotao="!habilitaCampos"
                                    :subItens="subItens"
                                    class="mr-2"
                                >
                                </btn-inserir-Subitem>
                                <btn-importar-SubItens
                                    :itemContrato="data"
                                    :desativarBotao="!habilitaCampos"
                                    v-on:subItens="quantidadeSubItens"
                                >
                                </btn-importar-SubItens>
                            </template>
                            <template slot="valor" slot-scope="data">
                                <span class="text-nowrap">{{
                                    data.valorUnitario | currency
                                }}</span>
                            </template>
                        </app-tabela>
                    </b-col>
                </b-row>
            </div>
        </b-card-body>
        <b-card-footer>
            <b-button
                variant="primary"
                @click.stop="salvarForm()"
                :disabled="!habilitarSalvar || !habilitaCampos"
                class="mr-2"
            >
                <i class="fa fa-save"></i>
                {{ textoBotao }}
            </b-button>
            <b-button variant="danger" @click.stop="cancelar()" class="mr-2">
                <span> <i class="fa fa-history mr-2"></i> Voltar </span>
            </b-button>
            <div class="float-right">
                <b-button
                    variant="success"
                    @click.stop="concluir()"
                    :disabled="!habilitarSalvar || !habilitaCampos"
                    v-if="$temAcessoView('CONT-PRE-02')"
                >
                    <span> <i class="fa fa-check"></i> Concluir </span>
                </b-button>
            </div>
        </b-card-footer>
    </b-card>
</template>

<script>
import BtnInserirItemContrato from './BtnInserirItemContrato'
import BtnEditarItemContrato from './BtnEditarItemContrato'
import BtnInserirSubitem from './BtnInserirSubItem'
import BtnImportarSubItens from './BtnImportarSubItens'
import { required } from 'vuelidate/lib/validators'
import PreContratoServicos from './PreContratoServicos'
import { situacaoContrato } from '../SituacaoContrato'
import { formasAutorizacao } from '../FormasAutorizacao'
import { tiposContratacao } from '../TiposContratacao'
import { tiposLicitacao } from '../TiposLicitacao'

export default {
    components: {
        BtnInserirItemContrato,
        BtnEditarItemContrato,
        BtnInserirSubitem,
        BtnImportarSubItens
    },

    data() {
        return {
            erros: [],
            contrato: {},
            preContratoDto: {
                idContrato: 0,
                ata: '',
                vcCodigoEstruturado: '',
                tpContratacao: 2,
                nuSaldoContrato: 0,
                nuValorGlobalContrato: 0,
                codTipoLicitacao: 1,
                dataAutorizacaoMapa: null,
                vcObjetoContrato: '',
                formaAutorizacao: 0,
                numeroMapa: '',
                idProcessoAta: 0,
                codFornecedor: '',
                vcProcessoAditivo: '',
                itensContrato: [],
                numProcessoLicitacao: null,
                idSituacaoContrato: situacaoContrato.PRE_CONTRATO_EM_ELABORACAO,
                usrLoginCadastro: this.$store.getters.usuario.login
            },
            processoAta: {
                id: 0,
                idAtaDirex: 0,
                vcObjetoProcesso: '',
                vcNomeSolicitanteGdoc: '',
                nuProcesso: ''
            },
            operacao: 'INSERIR',
            textoBotao: 'Salvar',
            tiposContratacao: tiposContratacao,
            tiposLicitacao: tiposLicitacao,
            tipoLicitacao: 1,
            tipoLicitacaoSelecionado: 'Pregão',
            formasAutorizacao: formasAutorizacao,
            mostraFormaAutorizacao: false,
            edicaoPreContrato: false,
            processosAta: [],
            numeroProcesso: 1,
            numeroMapa: '',
            fornecedor: {
                codFornecedor: '',
                cnpjcpf: '',
                razaoSocial: '',
                fornecedorExterno: false
            },
            cnpjcpfFornecedor: '',
            mostraNumeroMapa: false,
            mostraPesquisaAtaESelecaoDeProcesso: true,
            campos: [
                {
                    key: 'descricao',
                    label: 'Descrição',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'descricaoResumida',
                    label: 'Descrição resumida',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'valor',
                    label: 'Valor',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'quantidade',
                    label: 'Quantidade',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 5,
            selecionado: [],
            habilitaCampos: true,
            subItens: [],
            preContratoSalvo: false,
            preenchendoForm: true
        }
    },

    methods: {
        obterContrato() {
            this.$store.dispatch('addRequest')
            PreContratoServicos.obterPorId(this.$route.params.contratoId).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.contrato = response.data
                            this.converterContratoParaPrecontrato(this.contrato)
                            if (
                                this.preContratoDto.idSituacaoContrato ==
                                situacaoContrato.PRE_CONTRATO_CONCLUIDO
                            ) {
                                this.habilitaCampos = false
                                this.mudarTextoOperacao()
                            }
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        converterContratoParaPrecontrato(contrato) {
            this.preContratoDto.idContrato = contrato.idContrato
            this.preContratoDto.ata = contrato.nuAtaDirex
            this.preContratoDto.vcCodigoEstruturado =
                contrato.vcCodigoEstruturado

            this.preContratoDto.tpContratacao = contrato.tpContratacao

            if (this.preContratoDto.tpContratacao != 2) {
                this.selecionaTipoContratacao(this.preContratoDto.tpContratacao)

                this.preContratoDto.dataAutorizacaoMapa = this.$moment(
                    contrato.dataAutorizacaoMapa
                )
                this.preContratoDto.formaAutorizacao = contrato.formaAutorizacao
                this.preContratoDto.vcProcessoAditivo =
                    contrato.vcProcessoAditivo
            }

            this.preContratoDto.codTipoLicitacao = contrato.codTipoLicitacao
            this.preContratoDto.vcObjetoContrato = contrato.vcObjetoContrato
            this.preContratoDto.codFornecedor = contrato.fornecedor.codFornecedor
            this.fornecedor.fornecedorExterno = contrato.fornecedor.fornecedorExterno
            this.fornecedor.cnpjcpf = contrato.fornecedor.cnpj
            this.fornecedor.codFornecedor = contrato.fornecedor.codFornecedor
            this.fornecedor.razaoSocial = contrato.fornecedor.nome
            this.fornecedor.email = contrato.fornecedor.email
            this.fornecedor.telefone = contrato.fornecedor.telefone
            this.preContratoDto.itensContrato = contrato.itensContrato
            this.preContratoDto.idSituacaoContrato = contrato.idSituacaoContrato
            this.preContratoDto.numProcessoLicitacao =
                contrato.numProcessoLicitacao

            this.processosAta = contrato.processosAta
            this.processoAta.vcNomeSolicitanteGdoc =
                contrato.processoAta.vcNomeSolicitanteGdoc
            this.selecionado = this.processosAta.find(
                (p) => p.idProcessoAta == contrato.idProcessoAta
            ).idProcessoAta
            this.preContratoDto.idProcessoAta = contrato.idProcessoAta
            this.processoAta.nuProcesso = this.selecionado

            this.edicaoPreContrato = true
        },

        pesquisarAtaDirex() {
            if (this.preContratoDto.ata.length == 7) {
                this.$store.dispatch('addRequest')
                PreContratoServicos.obterProcessosPorNumeroAta(
                    this.preContratoDto.ata.replace('/', '-')
                ).then((response) => {
                    if (response) {
                        if (response.success) {
                            this.processosAta = response.data
                            this.processoAta = {}
                        } else {
                            this.processosAta = []
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
            }
        },

        obterProcessoPorNumero() {
            if (this.preContratoDto.vcProcessoAditivo.length == 12) {
                this.$store.dispatch('addRequest')
                PreContratoServicos.obterProcessoGedocPorNumero(
                    this.preContratoDto.vcProcessoAditivo
                ).then((response) => {
                    if (response) {
                        if (response.success && response.data != null) {
                            this.erros = []
                            this.processoAta.vcNomeSolicitanteGdoc =
                                response.data.nome
                            this.preContratoDto.vcObjetoContrato =
                                response.data.assunto
                        } else {
                            this.erros.push('Processo não encontrado')
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
            }
        },

        modificaNumeroAta() {
            if (this.preContratoDto.ata.length < 7) {
                this.processosAta = []
                this.processoAta = {}
                this.processoAta.vcNomeSolicitanteGdoc = ''
                this.preContratoDto.vcObjetoContrato = ''

                if (this.erros.length > 0) {
                    this.erros = []
                }
            }
        },

        modificaNumeroProcesso() {
            if (this.preContratoDto.vcProcessoAditivo.length < 12) {
                this.processoAta.vcNomeSolicitanteGdoc = ''
                this.preContratoDto.vcObjetoContrato = ''

                if (this.erros.length > 0) {
                    this.erros = []
                }
            }
        },

        formatCPF(value) {
            return value
                .replace(/(\d{3})(\d)/, "$1.$2")
                .replace(/(\d{3})(\d)/, "$1.$2")
                .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
        },

        formatCNPJ(value) {
            return value
                .replace(/^(\d{2})(\d)/, "$1.$2")
                .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
                .replace(/\.(\d{3})(\d)/, ".$1/$2")
                .replace(/(\d{4})(\d)/, "$1-$2");
        },

        pesquisarFornecedor() {
            var fornecedorId = this.fornecedor.fornecedorExterno ? this.fornecedor.codFornecedor : this.fornecedor.cnpjcpf.apenasNumeros();
            if(!/[a-zA-Z]/.test(fornecedorId) 
                && fornecedorId.length > 0 
                && (this.validaTamanhoCpfCnpj
                    || this.validaTamanhoCodFornecedor)
            ){
                let obterFornecedor = PreContratoServicos.obterFornecedorCpfCnpj
                if (this.fornecedor.fornecedorExterno)
                {
                    obterFornecedor = PreContratoServicos.obterFornecedorCod
                }

                this.$store.dispatch('addRequest')
                obterFornecedor(fornecedorId).then((response) => {
                    if (response) {
                        if (response.success && response.data != null) {
                            this.erros = []
                            this.fornecedor.razaoSocial = response.data.nome
                            this.fornecedor.cnpjcpf = response.data.cnpj
                            this.fornecedor.email = response.data.email
                            this.fornecedor.codFornecedor = response.data.codFornecedor
                            this.fornecedor.telefone = response.data.telefone
                            this.preContratoDto.codFornecedor =
                                response.data.codFornecedor
                        } else {
                            this.erros.push('Fornecedor não encontrado')
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
            }
        },

        salvarItemContrato(item) {
            if (this.preContratoDto.idContrato == 0) {
                if (!this.$v.$invalid) {
                    this.preContratoDto.itensContrato.push(item)
                    this.salvarForm()
                }
            } else {
                this.inserirItemContrato(item)
            }
        },

        obterItensContrato() {
            if (this.preContratoDto.idContrato != 0) {
                PreContratoServicos.obterItensContrato(
                    this.preContratoDto.idContrato
                ).then((response) => {
                    if (response) {
                        if (response.success) {
                            this.preContratoDto.itensContrato = response.data
                        }
                    }
                })
            }
        },

        confirmarRemocaoItemContrato(item) {
            if (this.habilitaCampos) {
                this.$swal({
                    title: 'Excluir item contrato',
                    html: `Confirma a exclusão do item do contrato?
                <br/><br/><div class="alert alert-danger" role="alert">
                        Atenção! Essa é uma operação irreversível!
                    </div>`,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim',
                    cancelButtonText: 'Não'
                }).then((result) => {
                    if (result.value) {
                        this.removerItemContrato(item)
                    }
                })
            }
        },

        removerItemContrato(item) {
            this.$store.dispatch('addRequest')
            PreContratoServicos.removerItemContrato(
                item.idContrato,
                item.itemContratoId
            ).then((response) => {
                if (response) {
                    if (response.success) {
                        this.preContratoDto.itensContrato = response.data
                        this.$toast.success(
                            'Item contrato removido com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                    } else {
                        this.$toast.error(response.errors, 'ERROR', this.error)
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        inserirItemContrato(itemContato) {
            itemContato.idContrato = this.preContratoDto.idContrato
            this.$store.dispatch('addRequest')
            PreContratoServicos.inserirItemContrato(itemContato).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.preContratoDto.itensContrato = response.data

                            this.$toast.success(
                                'Item adicionado com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.preContratoSalvo = true
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        atualizarItemContrato(itemContato) {
            itemContato.idContrato = this.preContratoDto.idContrato
            this.$store.dispatch('addRequest')
            PreContratoServicos.atualizarItemContrato(itemContato).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.preContratoDto.itensContrato = response.data

                            this.$toast.success(
                                'Sub item atualizado com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        quantidadeSubItens() {
            this.preContratoDto.itensContrato = []
            this.obterItensContrato()
        },

        calculaValoresItemContrato() {
            let valor = this.preContratoDto.itensContrato.reduce(
                (soma, item) => soma + item.valorUnitario,
                0
            )
            this.preContratoDto.nuSaldoContrato = valor
            this.preContratoDto.nuValorGlobalContrato = valor
        },

        selecionaTipoContratacao(value) {
            if (value == 1 || value == 3 || value == 4 || value == 5) {
                this.mostraFormaAutorizacao = true
                this.mostraNumeroMapa = false
                this.mostraPesquisaAtaESelecaoDeProcesso = false
                this.numeroMapa = ''
                this.preContratoDto.vcProcessoAditivo = ''
                this.processoAta.vcNomeSolicitanteGdoc = ''
                this.preContratoDto.vcObjetoContrato = ''
                this.preContratoDto.idProcessoAta = 0
                if (value == 3) {
                    this.mostraNumeroMapa = true
                }
                if (value == 5) {
                    this.preContratoDto.numProcessoLicitacao =
                        'TERMO CADASTRAMENTO'
                }
            } else {
                this.mostraFormaAutorizacao = false
                this.mostraNumeroMapa = false
                this.preContratoDto.dataAutorizacaoMapa = null
                this.mostraPesquisaAtaESelecaoDeProcesso = true
                this.preContratoDto.vcProcessoAditivo = ''
                this.preContratoDto.vcObjetoContrato = ''
                this.processoAta.vcNomeSolicitanteGdoc = ''
            }
            this.formaAutorizacao = 0
        },

        mudarLabelReferenteLicitacao(value) {
            this.tipoLicitacaoSelecionado = this.tiposLicitacao.find(
                (x) => x.value == value
            ).text
        },

        selecionaNumeroProcesso(value) {
            let processo = this.processosAta.find(
                (x) => x.idProcessoAta == value
            )

            this.processoAta.vcNomeSolicitanteGdoc =
                processo.vcNomeSolicitanteGdoc
            this.preContratoDto.vcObjetoContrato = processo.vcObjetoProcesso
            this.preContratoDto.idProcessoAta = processo.idProcessoAta
        },

        salvarForm() {
            this.calculaValoresItemContrato()

            this.preContratoDto.fornecedor = {
                cnpj: this.fornecedor.cnpjcpf,
                nome: this.fornecedor.razaoSocial,
                email: this.fornecedor.email,
                telefone: this.fornecedor.telefone,
                codFornecedor: this.fornecedor.codFornecedor,
                fornecedorExterno: this.fornecedor.fornecedorExterno
            }

            if (this.preContratoDto.dataAutorizacaoMapa != null) {
                this.preContratoDto.dataAutorizacaoMapa = this.$moment(
                    this.preContratoDto.dataAutorizacaoMapa,
                    'DD/MM/YYYY'
                ).format('YYYY-MM-DD')
            }

            if (this.preContratoDto.tpContratacao == 5) {
                this.preContratoDto.codTipoLicitacao = 8
            }

            if (this.preContratoDto.idContrato > 0) {
                this.$store.dispatch('addRequest')
                PreContratoServicos.atualizarPreContrato(
                    this.preContratoDto
                ).then((response) => {
                    if (response) {
                        if (response.success) {
                            if (
                                this.preContratoDto.idSituacaoContrato ==
                                situacaoContrato.PRE_CONTRATO_EM_ELABORACAO
                            ) {
                                if (
                                    this.preContratoDto.dataAutorizacaoMapa !=
                                    null
                                ) {
                                    this.preContratoDto.dataAutorizacaoMapa =
                                        this.$moment(
                                            this.preContratoDto
                                                .dataAutorizacaoMapa
                                        ).format('DD/MM/YYYY')
                                }
                                this.$toast.success(
                                    'Pré contrato atualizado com sucesso!',
                                    'OK',
                                    this.$toastConfig.success
                                )
                            } else {
                                this.$toast.success(
                                    'Pré contrato concluído!',
                                    'OK',
                                    this.$toastConfig.success
                                )
                                this.mudarTextoOperacao()
                            }
                            this.preContratoSalvo = true
                        } else {
                            this.erros = response.errors
                            if (
                                this.preContratoDto.dataAutorizacaoMapa != null
                            ) {
                                this.preContratoDto.dataAutorizacaoMapa =
                                    this.$moment(
                                        this.preContratoDto.dataAutorizacaoMapa,
                                        'YYYY-MM-DD'
                                    ).format('DD/MM/YYYY')
                            }
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
            } else {
                this.$store.dispatch('addRequest')
                PreContratoServicos.inserirPreContrato(
                    this.preContratoDto
                ).then((response) => {
                    if (response) {
                        if (response.success) {
                            this.preContratoDto.itensContrato =
                                response.data.itensContrato
                            this.preContratoDto.idContrato =
                                response.data.idContrato
                            this.preContratoDto.idProcessoAta =
                                response.data.idProcessoAta

                            if (
                                this.preContratoDto.idSituacaoContrato ==
                                situacaoContrato.PRE_CONTRATO_EM_ELABORACAO
                            ) {
                                if (
                                    this.preContratoDto.dataAutorizacaoMapa !=
                                    null
                                ) {
                                    this.preContratoDto.dataAutorizacaoMapa =
                                        this.$moment(
                                            this.preContratoDto
                                                .dataAutorizacaoMapa
                                        ).format('DD/MM/YYYY')
                                }
                                this.$toast.success(
                                    'Pré contrato salvo com sucesso!',
                                    'OK',
                                    this.$toastConfig.success
                                )
                                this.habilitaCampos = true
                            } else {
                                this.$toast.success(
                                    'Pré contrato concluído!',
                                    'OK',
                                    this.$toastConfig.success
                                )
                                this.mudarTextoOperacao()
                            }
                            this.preContratoSalvo = true
                            this.erros = []
                        } else {
                            this.habilitaCampos = true
                            this.erros = response.errors
                            if (
                                this.preContratoDto.dataAutorizacaoMapa != null
                            ) {
                                this.preContratoDto.dataAutorizacaoMapa =
                                    this.$moment(
                                        this.preContratoDto.dataAutorizacaoMapa,
                                        'YYYY-MM-DD'
                                    ).format('DD/MM/YYYY')
                            }
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
            }
        },

        mudarTextoOperacao() {
            if (this.$route.params.contratoId) {
                this.operacao = 'EDIÇÃO'
            }

            if (
                this.preContratoDto.idSituacaoContrato ==
                situacaoContrato.PRE_CONTRATO_CONCLUIDO
            ) {
                this.operacao = 'CONCLUÍDO'
            }
        },

        cancelar() {
            this.erros = []
            if (this.preContratoSalvo) {
                this.$store.dispatch('setRecarregar', true)
            }
            this.$router.push({ name: 'Contratos' })
        },

        concluir() {
            this.preContratoDto.idSituacaoContrato =
                situacaoContrato.PRE_CONTRATO_CONCLUIDO
            this.salvarForm()
            this.habilitaCampos = false
        },

        tipoContratacaoEscolhida() {
            if (this.preContratoDto.tpContratacao == 2) {
                return true
            } else if (
                this.preContratoDto.tpContratacao != 2 &&
                this.preContratoDto.dataAutorizacaoMapa != null &&
                this.preContratoDto.formaAutorizacao != 0
            ) {
                return true
            }
            return false
        },

        valorNumeroProcessoENumeroAta() {
            if (this.preContratoDto.tpContratacao != 2) {
                if (this.preContratoDto.vcProcessoAditivo != '') {
                    return true
                }
            } else if (this.preContratoDto.tpContratacao == 2) {
                if (this.preContratoDto.ata != '') {
                    return true
                }
            }
            return false
        },

        numeroProcessoEscolhido() {
            if (!this.mostraPesquisaAtaESelecaoDeProcesso) {
                return true
            } else {
                return this.processoAta.nuProcesso != 0
            }
        },

        validaTamanhoCpfCnpj() {
            if (!this.fornecedor.fornecedorExterno && this.fornecedor.cnpjcpf != null) {
                return (
                    this.fornecedor.cnpjcpf.length == '14' ||
                    this.fornecedor.cnpjcpf.length == '18'
                )
            }
            if(this.fornecedor.fornecedorExterno){
                return true
            }
            return false
        },

        validaTamanhoCodFornecedor()
        {
            if(this.fornecedor.fornecedorExterno && this.fornecedor.codFornecedor != null) {
                return this.fornecedor.codFornecedor.length == '8'
            }
            if(!this.fornecedor.fornecedorExterno){
                return true
            }
            return false
        }
    },

    created() {
        if (this.$route.params.contratoId) {
            this.mudarTextoOperacao()
            this.textoBotao = 'Atualizar'
            
            this.obterContrato()
        }
    },

    computed: {
        habilitarSalvar() {
            return !this.$v.$invalid
        },

        isTermoCadastramento() {
            return this.preContratoDto.tpContratacao == 5
        }
    },

    watch: {
        'fornecedor.fornecedorExterno'() {
            if (this.preenchendoForm) {
                this.preenchendoForm = false
                return
            }
            this.fornecedor.codFornecedor = null
            this.fornecedor.cnpjcpf = null
        },

        'fornecedor.cnpjcpf'() {
            if(this.fornecedor.cnpjcpf != null && this.fornecedor.cnpjcpf.length > 0)
            {
                let onlyNumbers = this.fornecedor.cnpjcpf.replace(/\D/g, "");
                if (onlyNumbers.length <= 11) {
                    this.fornecedor.cnpjcpf = null;
                    this.fornecedor.cnpjcpf = this.formatCPF(onlyNumbers);
                } 
                else if (onlyNumbers.length > 11 && onlyNumbers.length < 14) {
                    this.fornecedor.cnpjcpf = onlyNumbers;
                }
                else if (onlyNumbers.length === 14) {
                    this.fornecedor.cnpjcpf = this.formatCNPJ(onlyNumbers);
                }
            }
        },

        'fornecedor.codFornecedor'() {
            if(this.fornecedor.codFornecedor != null && this.fornecedor.codFornecedor.length > 0)
            {
                let onlyNumbers = this.fornecedor.codFornecedor.replace(/\D/g, "");
                this.fornecedor.codFornecedor = onlyNumbers;
            }
        }
    },

    validations: {
        preContratoDto: {
            ata: {
                numeroAta() {
                    return this.valorNumeroProcessoENumeroAta()
                }
            },
            dataAutorizacaoMapa: {
                tipoContratacao() {
                    return this.tipoContratacaoEscolhida()
                }
            },
            vcObjetoContrato: {
                required
            },
            vcProcessoAditivo: {
                processoAditivo() {
                    return this.valorNumeroProcessoENumeroAta()
                }
            },
            numProcessoLicitacao: {
                required
            }
        },
        processoAta: {
            nuProcesso() {
                return this.numeroProcessoEscolhido()
            }
        },
        fornecedor: {
            cnpjcpf: {
                validaCpfCnpj() {
                    return this.validaTamanhoCpfCnpj()
                }
            },
            razaoSocial: {
                required
            },
            codFornecedor: {
                validaCodFornecedor() {
                    return this.validaTamanhoCodFornecedor()
                }
            }
        }
    }
}
</script>
